export const DropdownHeader = ({ className, children, tag: Tag = 'h6', style, ...rest }) => {
  const classes = `popover-header ${className || ''}`.trim();
  const customStyle = { ...style, fontSize: '0.92rem' };
  return (
    <Tag className={classes} style={customStyle} {...rest}>
      {children}
    </Tag>
  );
};
